
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Preweddingdestinationneargadchirily() {



  const cardData =
  {
    keyword: ' Pre-Wedding Destination Near Gadchiroli',
    heading:  'Woodland Escape: Pre-Wedding Destination Near Gadchiroli ',
    headingDescription: 'Woodland Escape Resort is a dreamy pre-wedding destination near Gadchiroli, offering couples a perfect mix of natural beauty, privacy, and elegance for their special moments. Surrounded by lush forests, open green lawns, and serene walkways, the resort creates a picturesque setting ideal for pre-wedding shoots, engagement celebrations, or intimate gatherings. Every corner reflects rustic charm blended with modern comfort — from cozy cottages for stayovers to scenic spots that make every photo come alive. Couples can capture timeless memories against misty backdrops, enjoy candlelight dinners under the stars, and celebrate love in nature’s quiet embrace. With personalized arrangements, warm hospitality, and breathtaking landscapes, Woodland Escape Resort near Gadchiroli turns every pre-wedding experience into a magical story of romance and togetherness.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Pre-Wedding Destination Near Gadchiroli",
      "description": "Discover the best pre-wedding destinations near Gadchiroli offering scenic locations, romantic settings, and picturesque spots for memorable pre-wedding photography."
    },
    {
      "name": "Gadchiroli Pre Wedding Shoot Spot",
      "description": "Plan your pre-wedding shoot at Gadchiroli’s top locations with beautiful landscapes, serene surroundings, and perfect lighting for stunning photos."
    },
    {
      "name": "Gadchiroli Romantic Shoot Location",
      "description": "Capture romantic moments in Gadchiroli at locations designed for couples, featuring natural beauty, privacy, and charming backdrops."
    },
    {
      "name": "Gadchiroli Outdoor Pre Wedding Spot",
      "description": "Enjoy outdoor pre-wedding shoots in Gadchiroli with lush greenery, riversides, hills, and open spaces for creative and memorable photography."
    },
    {
      "name": "Affordable Pre Wedding Spot Gadchiroli",
      "description": "Experience budget-friendly pre-wedding photography locations in Gadchiroli that provide stunning views, privacy, and convenience without exceeding your budget."
    },
    {
      "name": "Gadchiroli Resort Pre Wedding Shoot",
      "description": "Plan a pre-wedding shoot at Gadchiroli’s resorts offering scenic backdrops, comfortable amenities, and romantic settings for an elegant photo session."
    },
    {
      "name": "Gadchiroli Scenic Pre Wedding Spot",
      "description": "Choose Gadchiroli’s most scenic locations for pre-wedding photography, featuring panoramic views, beautiful landscapes, and natural charm."
    },
    {
      "name": "Gadchiroli Riverside Pre Wedding Location",
      "description": "Capture serene and romantic riverside moments in Gadchiroli with calm waters, open spaces, and perfect lighting for a memorable shoot."
    },
    {
      "name": "Gadchiroli Hill Pre Wedding Spot",
      "description": "Enjoy hilltop pre-wedding photography in Gadchiroli with breathtaking views, fresh air, and dramatic natural backdrops."
    },
    {
      "name": "Gadchiroli Couple Shoot Location",
      "description": "Plan intimate couple photography in Gadchiroli at locations that provide privacy, scenic beauty, and creative opportunities for timeless shots."
    },
    {
      "name": "Gadchiroli Pre Wedding Tour",
      "description": "Explore Gadchiroli with guided pre-wedding tours that include multiple scenic locations, transportation, and photography guidance for a seamless experience."
    },
    {
      "name": "Gadchiroli One Day Pre Wedding Shoot",
      "description": "Complete your pre-wedding shoot in one day at Gadchiroli, visiting the most picturesque spots and capturing memories efficiently."
    },
    {
      "name": "Gadchiroli Photography Spot",
      "description": "Discover the best photography spots in Gadchiroli ideal for pre-wedding shoots, featuring natural beauty, scenic landscapes, and peaceful surroundings."
    },
    {
      "name": "Gadchiroli Booking for Pre Wedding Shoot",
      "description": "Easily book your preferred Gadchiroli pre-wedding shoot locations online to secure dates, amenities, and hassle-free access for your photography session."
    },
    {
      "name": "Gadchiroli Pre Wedding Packages",
      "description": "Choose from curated pre-wedding packages in Gadchiroli that include location access, photography services, transport, and optional styling support for a complete experience."
    }
  ],
  "tableData": [
    ["- Pre-Wedding Destination Near Gadchiroli", "- Gadchiroli Pre Wedding Shoot Spot"],
    ["- Gadchiroli Romantic Shoot Location", "- Gadchiroli Outdoor Pre Wedding Spot"],
    ["- Affordable Pre Wedding Spot Gadchiroli", "- Gadchiroli Resort Pre Wedding Shoot"],
    ["- Gadchiroli Scenic Pre Wedding Spot", "- Gadchiroli Riverside Pre Wedding Location"],
    ["- Gadchiroli Hill Pre Wedding Spot", "- Gadchiroli Couple Shoot Location"],
    ["- Gadchiroli Pre Wedding Tour", "- Gadchiroli One Day Pre Wedding Shoot"],
    ["- Gadchiroli Photography Spot", "- Gadchiroli Booking for Pre Wedding Shoot"],
    ["- Gadchiroli Pre Wedding Packages", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect Pre-Wedding Destination Near Gadchiroli",
    "WhyChoosedescription": "Woodland Escape Resort is an idyllic venue for pre-wedding shoots near Gadchiroli. Surrounded by lush greenery and scenic landscapes, it offers a romantic and serene backdrop for capturing your special moments."
  },
  {
    "WhyChooseheading": "Scenic Outdoor Locations",
    "WhyChoosedescription": "The resort features beautiful gardens, open lawns, and forested surroundings, providing stunning natural settings for pre-wedding photography that feels magical and timeless."
  },
  {
    "WhyChooseheading": "Private and Peaceful Ambiance",
    "WhyChoosedescription": "Enjoy an intimate and tranquil environment, perfect for couples looking to create cherished pre-wedding memories away from crowds and distractions."
  },
  {
    "WhyChooseheading": "Spacious Areas for Photoshoots",
    "WhyChoosedescription": "Woodland Escape Resort offers expansive lawns, cozy sit-outs, and picturesque spots ideal for both candid and posed pre-wedding shoots, allowing flexibility for creative photography."
  },
  {
    "WhyChooseheading": "Comfortable Stay for Couples",
    "WhyChoosedescription": "The resort provides comfortable rooms and cottages, ensuring a relaxed and pleasant experience while you focus on your pre-wedding shoot and celebrations."
  },
  {
    "WhyChooseheading": "Customized Pre-Wedding Services",
    "WhyChoosedescription": "The resort team can assist with shoot arrangements, decor, and other requirements to make your pre-wedding experience seamless and memorable."
  },
  {
    "WhyChooseheading": "Easily Accessible from Gadchiroli",
    "WhyChoosedescription": "Located just a short drive from Gadchiroli, Woodland Escape Resort is convenient for couples seeking a quick and beautiful destination for their pre-wedding photography and celebrations."
  }
]






















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a pre-wedding destination near Gadchiroli?",
    answer: "Woodland Escape Resort is an ideal pre-wedding destination near Gadchiroli, offering lush green landscapes, serene surroundings, and beautiful backdrops for photoshoots. It’s perfect for capturing memorable moments before the big day."
  },
  {
    question: "How far is Woodland Escape Resort from Gadchiroli city?",
    answer: "The resort is conveniently located within driving distance from Gadchiroli, making it easy for couples and their families to reach and enjoy a stress-free pre-wedding shoot or celebration."
  },
  {
    question: "What facilities does Woodland Escape Resort offer for pre-wedding events?",
    answer: "The resort provides scenic lawns, elegant décor options, spacious areas for photoshoots, and cozy corners for candid shots. It also accommodates small pre-wedding gatherings and celebrations."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and friends joining pre-wedding events?",
    answer: "Yes! The resort is family-friendly and group-friendly, providing safe, spacious, and comfortable surroundings for everyone attending pre-wedding activities."
  },
  {
    question: "Does the resort provide catering and decoration services for pre-wedding shoots or events?",
    answer: "Absolutely. Woodland Escape Resort offers catering services, snacks, beverages, and optional décor arrangements to make your pre-wedding experience seamless and enjoyable."
  },
  {
    question: "How can we book Woodland Escape Resort for a pre-wedding destination near Gadchiroli?",
    answer: "Booking is simple — you can call or WhatsApp our reservations team, or visit the official website. Advance booking is recommended to secure your preferred dates and arrangements."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Deshmukh, Gadchiroli",
    text: "Our pre-wedding shoot at Woodland Escape Resort was magical! The natural surroundings and beautiful spaces made every photo perfect. Highly recommended for couples near Gadchiroli."
  },
  {
    name: "Ms. Neha & Mr. Rohan, Gadchiroli",
    text: "We chose Woodland Escape Resort for our pre-wedding photoshoot and loved it! The greenery, peaceful environment, and friendly staff made the experience wonderful. Truly the best pre-wedding destination near Gadchiroli."
  }
];























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pre-Wedding Destination Near Gadchiroli",
  "image": "https://woodlandescape.com/assets/images/pre-wedding-gadchiroli.jpg",
  "description": "Capture your special moments at Woodlandescape Resort, the perfect pre-wedding destination near Gadchiroli. Ideal for romantic outdoor shoots, scenic riverside and hill locations, and one-day pre-wedding tours.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "88"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/pre-wedding-gadchiroli"
  }
};




  return (
    <div>
<Helmet>
  <title>Pre-Wedding Destination Near Gadchiroli | Romantic Shoot & Scenic Locations | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan your pre-wedding shoot at Woodlandescape Resort near Gadchiroli. Enjoy romantic outdoor spots, riverside and hill views, and scenic locations for your perfect couple photography." 
  />
  <meta 
    name="keywords" 
    content="Pre-Wedding Destination Near Gadchiroli, Gadchiroli Pre Wedding Shoot Spot, Gadchiroli Romantic Shoot Location, Gadchiroli Outdoor Pre Wedding Spot, Affordable Pre Wedding Spot Gadchiroli, Gadchiroli Resort Pre Wedding Shoot, Gadchiroli Scenic Pre Wedding Spot, Gadchiroli Riverside Pre Wedding Location, Gadchiroli Hill Pre Wedding Spot, Gadchiroli Couple Shoot Location, Gadchiroli Pre Wedding Tour, Gadchiroli One Day Pre Wedding Shoot, Gadchiroli Photography Spot, Gadchiroli Booking for Pre Wedding Shoot, Gadchiroli Pre Wedding Packages" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/31.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Preweddingdestinationneargadchirily;